import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function InvoiceSeriesPage() {
  return (
    <MainLayout>
      <SEO 
        title="Séries de notas fiscais"
        description="Gerencie séries de notas fiscais"
        keywords="notas fiscais, séries, serviços"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Séries de notas fiscais</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

